import { render } from "./BCardHeader.vue?vue&type=template&id=4e37043a&ts=true"
import script from "./BCardHeader.vue?vue&type=script&lang=ts"
export * from "./BCardHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__